import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import FormSeriesMedicalStep, { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import { ComposedGeneralMedicalQuestions, GeneralMedicalQuestionsEvaluator } from "./ComposedGeneralMedicalQuestions";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredGeneralMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  FormSeriesMedicalStep({
    ...props,
    nextStep: Step.medicalPacemaker,
    medicalQualificationEvaluator: GeneralMedicalQuestionsEvaluator,
    FormQuestions: ComposedGeneralMedicalQuestions,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedGeneralMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredGeneralMedicalStep>
>({
  Component: ConfiguredGeneralMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedGeneralMedicalStep;
